<script lang="ts" setup>
defineProps({
  box: {
    type: Object,
    default: () => ({}),
  },
  layout: {
    type: String,
    default: 'default',
  },
})
</script>

<template>
  <div
    :class="[
      'text-in-box',
      `text-in-box--${layout}`
    ]"
  >
    <img
      v-if="box.image"
      class="text-in-box__image"
      :src="box.image"
    >

    <div class="text-in-box__content">
      <span
        v-if="box.abovetext"
        class="text-in-box__abovetext"
      >
        {{ box.abovetext }}
      </span>

      <div
        class="text-in-box__text"
        v-html="box.text"
      />
      
      <span class="text-in-box__subtext">
        {{ box.subtext }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.text-in-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: -1.6rem;
  margin-left: -1.6rem;
  padding: 3.2rem 2.2rem;
  font-weight: 500;
  text-align: center;
  border-radius: 1.6rem;

  @include atM {
    flex-direction: row;
    max-width: 115.2rem;
    margin: 0;
    margin: 0 auto;
    padding: 5.6rem;
    text-align: left;
  }

  @include atXL {
    max-width: 134rem;
  }

  &--default {
    border: 2px solid $gray-200;
  }

  &--layout-1 {
    @include atM {
      text-align: center;
    }
  }

  &__image {
    width: 18rem;
    height: 8rem;
    margin-bottom: 2.4rem;
    border-radius: 1.6rem;
    object-fit: cover;
    object-position: top -40px right 0;

    @include atM {
      width: 21rem;
      height: 29rem;
      margin-right: 7.2rem;
      margin-bottom: 0;
      object-position: center;
    }
  }

  &__text {
    margin-bottom: 1.6rem;
    font-weight: 500;
    font-size: 2rem;
    line-height: 2.8rem;

    :deep() {
      span {
        color: var(--span-color);
      }
    }

    @include atM {
      margin-bottom: 4rem;
      font-size: 3.2rem;
      line-height: 4rem;
    }

    @include atXL {
      font-size: 4rem;
      line-height: 4.8rem;
    }
  }

  &__abovetext {
    display: inline-block;
    margin-bottom: 1.8rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
    border-bottom: 0.2rem solid var(--span-color);

    @include atM {
      margin-bottom: 2.4rem;
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }

  &__subtext {
    color: $text-200;
    font-size: 1.6rem;
    line-height: 2.4rem;

    @include atM {
      font-size: 2rem;
      line-height: 2.8rem;
    }
  }
}
</style>
